export default {
    Home: '首页',
    Markets: '行情',
    Trade: '交易',
    Futures: '合约',
    Finance: '理财',
    login: "登录",
}
